const VEHICLES_REMOVE = {
  CONFIRMATION_MESSAGE: (
    recordsLength
  ) => `Se ${recordsLength == 1 ? `quitará ${recordsLength} vehículo` : `quitarán ${recordsLength} vehículos`} del contrato ¿Estás seguro de continuar?`,
  MAX_STEPS: 3,
  STEPS: {
    1: {
      title: 'Carga de archivos',
      subtitle:
        'Adjunta el archivo Excel con la información de los vehículos a dar de baja del contrato.',
    },
    2: {
      title: 'Valida los datos extraídos',
      subtitle: 'Asegúrate que la información de los vehículos sea correcta.',
    },
    3: {
      title: 'Valida los datos extraídos',
      subtitle: 'Asegúrate que la información de los vehículos sea correcta.',
    },
  },
  NEED_FILES: false,
  SUCCESS_MESSAGE: ''
};

export const MASSIVE_CHANGE_TYPES_INFO = {
  VEHICLES_REMOVE,
};
